import React from 'react';
import StepTemplateLogo from 'step_template_logo';

var StepTemplateCategory = React.createClass({
    propTypes: {
        name: React.PropTypes.string.isRequired,
        templates: React.PropTypes.array.isRequired,
        resolveLink: React.PropTypes.func.isRequired,
        onCategorySelected: React.PropTypes.func.isRequired,
    },
    render: function() {

        var firstTemplate = this.props.templates[0];

        return <li className="step-category animated" onClick={this.props.onCategorySelected}>
            <StepTemplateLogo size="medium" url={firstTemplate.Links.Logo} resolveLink={this.props.resolveLink} enableCacheBreaker={false} />

            <div className="category-name">
                {this.props.name}
            </div>
        </li>;
    }
});

export default StepTemplateCategory;







// WEBPACK FOOTER //
// ./app/areas/projects/step-templates/step_template_category.jsx